import { configureApi, createQueryClient, type CreateQueryClientOptions } from '@pa/api'
import type { QueryClient } from '@tanstack/react-query'
import type { PatientEnv } from './env'

/** Reads time out after 10 s; lookup and booking pass their own (Frontend §3.2). */
export const DEFAULT_TIMEOUT_MS = 10_000

/** `configureApi()` for the patient app: cookies (`credentials: 'include'`), no token (Frontend §3.2). */
export function setupApi(env: PatientEnv): void {
  configureApi({
    baseUrl: env.VITE_API_ORIGIN,
    credentials: 'include',
    defaultTimeoutMs: DEFAULT_TIMEOUT_MS,
    validateResponses: env.VITE_ENV !== 'prod',
  })
}

export const createPatientQueryClient = (options?: CreateQueryClientOptions): QueryClient =>
  createQueryClient('patient', options)
